import { http } from '@/utils/plugins/http'
export const getProductImages = (id) => http.get(`/images?product_id=${id}`)
export const deleteProductImage = (id) => http.delete(`images/${id}`)
export const deleteMultipleProductImages = (payload) => http.delete(`images/multiple_delete`, { data : payload })
export const getImageSuggestions = ({ searchBy, searchValue, src }) => http.get(`images/suggestion?search_by=${searchBy}&search_value=${searchValue}&src=${src}`)
export const syncImage = (id) => http.post(`/products/${id}/sync_images`)
export const addImageFromUrl = (payload) => http.post('images/create_from_url', payload)
export const getProductImageSuggestions = (productId) => http.get(`products/${productId}/image_suggestions`)
export const uploadProductImage = (payload) => http.post('images', payload)
